import React from 'react';
import {
  Card,
  CardContent,
  Typography,
  Grid,
  Divider,
  Box,
} from '@mui/material';
import { Fonts } from '@projectK/constants/AppEnums';
import PropTypes from 'prop-types';
const getPrice = (cartItems) => {
  let total = 0;
  cartItems?.length > 0 &&
    cartItems?.map((data) => {
      total = total + data.item_price * +data.quantity;
      return data;
    });
  return total;
};
const getTotalPrice = (cartItems) => {
  let total = 0;
  cartItems?.length > 0 &&
    cartItems?.map((data) => {
      let price;
      // Check if payment_plan_id exists and is_deposit is true
      if (data.payment_plan_id && data.is_deposit) {
        price = data.remaining_amount * data.payment_plan_id;
      } else if (data.payment_plan_id && !data.is_deposit) {
        price = data.item_price * data.payment_plan_id;
      } else if (!data.payment_plan_id && data.is_deposit) {
        price = data.item_price + data.remaining_amount;
      } else {
        // Use remaining_amount if it exists, otherwise fallback to item_price
        price = data.item_price;
      }

      total += price * +data.quantity;
      return data;
    });
  return total;
};

const calculateDiscountedPrice = (
  totalPrice,
  promoDiscountType,
  discountValue,
  promoDiscountValue,
  discount,
) => {
  let PaymentDiscount = 0;
  if (discount && promoDiscountType === 'percentage') {
    PaymentDiscount = (totalPrice * parseFloat(promoDiscountValue)) / 100;
  } else if (discount && promoDiscountType === 'fixed') {
    PaymentDiscount = (totalPrice * parseFloat(discountValue)) / 100;
  }

  return PaymentDiscount;
};
const OrderSummary = ({
  cartItems,
  discount,
  fee,
  promoDiscountType,
  promoDiscountValue,
}) => {
  let totalPrice = 0;
  let caltotalprice = 0;
  let fullPayments = 0;
  let recurringPayments = 0;
  let depositPayments = 0;
  let depositRecurringPayments = 0;

  let totalPriceForFullPayemnt = 0;
  let totalPriceForRecurringPayment = 0;
  let TotalFordepositPayments = 0;
  let TotalFordepositRecurringPayments = 0;
  if (cartItems?.length > 0) {
    totalPrice = getPrice(cartItems);
    caltotalprice = getTotalPrice(cartItems);
    fullPayments = cartItems?.filter(
      (item) => item?.payment_plan_id === null && item?.is_deposit === 0,
    );

    recurringPayments = cartItems?.filter(
      (item) => item?.payment_plan_id !== null && item?.is_deposit === 0,
    );
    depositPayments = cartItems?.filter(
      (item) => item?.payment_plan_id === null && item?.is_deposit === 1,
    );
    depositRecurringPayments = cartItems?.filter(
      (item) => item?.payment_plan_id !== null && item?.is_deposit === 1,
    );
    totalPriceForFullPayemnt = getTotalPrice(fullPayments);
    totalPriceForRecurringPayment = getPrice(recurringPayments);
    TotalFordepositPayments = getPrice(depositPayments);
    TotalFordepositRecurringPayments = getPrice(depositRecurringPayments);
  }

  const discountValue = discount
    ? (promoDiscountValue / caltotalprice) * 100
    : 0;
  let fullPaymentDiscount = 0;
  fullPaymentDiscount = calculateDiscountedPrice(
    totalPriceForFullPayemnt,
    promoDiscountType,
    discountValue,
    promoDiscountValue,
    discount,
  );
  const discountedTotalForFullPayment =
    discount && promoDiscountType
      ? totalPriceForFullPayemnt - fullPaymentDiscount
      : totalPriceForFullPayemnt;

  const feePercentageForFullPayment = fee
    ? discountedTotalForFullPayment * (fee / 100)
    : 0;
  const totalWithFeeForFullPayment = (
    discountedTotalForFullPayment + feePercentageForFullPayment
  ).toFixed(2);

  let fullRecurringDiscount = 0;
  fullRecurringDiscount = calculateDiscountedPrice(
    totalPriceForRecurringPayment,
    promoDiscountType,
    discountValue,
    promoDiscountValue,
    discount,
  );

  const discountedTotalForRecurringPayment = discount
    ? totalPriceForRecurringPayment - fullRecurringDiscount
    : totalPriceForRecurringPayment;
  const feePercentageForRecurringPayment = fee
    ? discountedTotalForRecurringPayment * (fee / 100)
    : 0;
  const feePercentageForDepositPayment = fee
    ? TotalFordepositPayments * (fee / 100)
    : 0;
  const feePercentageForDepositRecurringPayment = fee
    ? TotalFordepositRecurringPayments * (fee / 100)
    : 0;

  const totalWithFeeForRecurringPayment = (
    discountedTotalForRecurringPayment + feePercentageForRecurringPayment
  ).toFixed(2);

  const totalWithFeeForDepositPayment = (
    TotalFordepositPayments + feePercentageForDepositPayment
  ).toFixed(2);
  const totalWithFeeForDepositRecuringPayment = (
    TotalFordepositRecurringPayments + feePercentageForDepositRecurringPayment
  ).toFixed(2);

  return (
    <Card
      sx={{
        margin: '0rem auto',
        padding: '1rem',
        borderRadius: '8px',
        boxShadow: 1,
        height: '100%',
        maxHeight: { xs: 'auto', sm: '450px' },
        overflowY: 'auto',
      }}
    >
      <Typography
        variant='h4'
        sx={{ mb: 4, fontWeight: 'bold', textAlign: 'center' }}
      >
        Payment Information
      </Typography>
      <CardContent sx={{ padding: 0 }}>
        <Grid container justifyContent='space-between' alignItems='center'>
          <Typography variant='h4' fontWeight='bold'>
            Order Summary
          </Typography>
        </Grid>
        <Box sx={{ mt: 2 }}>
          {cartItems?.map((items, index) => {
            let teamLabel = [
              items?.team_name || 'Unnamed Team',
              items?.division_name,
              items.tournament_name,
            ]
              .filter(Boolean)
              .join(' - ');
            return (
              <Grid
                key={index + 1}
                container
                justifyContent='space-between'
                sx={{ mb: 1 }}
              >
                <Typography variant='body1'>{teamLabel}</Typography>
                <Typography variant='body1'>$ {items.item_price}</Typography>
              </Grid>
            );
          })}
          <Divider sx={{ mb: 2 }} />
        </Box>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            fontSize: 14,
            fontWeight: Fonts.MEDIUM,
            mt: 2,
            mb: 4,
          }}
        >
          <Box sx={{ color: 'text.secondary' }}>Total: </Box>
          <Box>${totalPrice.toFixed(2)}</Box>
        </Box>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            fontSize: 14,
            fontWeight: Fonts.MEDIUM,
            mb: 4,
          }}
        >
          <Box sx={{ color: 'text.secondary' }}>Discount: </Box>
          <Box>
            $
            {discount !== null
              ? (
                  parseFloat(fullPaymentDiscount) +
                  parseFloat(fullRecurringDiscount)
                ).toFixed(2)
              : '0.00'}
          </Box>
        </Box>

        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            fontSize: 14,
            fontWeight: Fonts.MEDIUM,
            mb: 4,
          }}
        >
          <Box sx={{ color: 'text.secondary' }}>{'Convenience Fee'}:</Box>
          {cartItems?.length > 0 ? (
            <Box>
              $
              {(
                parseFloat(feePercentageForFullPayment) +
                parseFloat(feePercentageForRecurringPayment) +
                parseFloat(feePercentageForDepositRecurringPayment) +
                parseFloat(feePercentageForDepositPayment)
              ).toFixed(2)}
            </Box>
          ) : (
            <Box>0 </Box>
          )}
        </Box>

        <Divider />

        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            fontSize: 14,
            fontWeight: Fonts.MEDIUM,
            my: 4,
          }}
        >
          <Box sx={{ color: 'text.secondary' }}>Grand Total: </Box>
          <Box>
            $
            {(
              parseFloat(totalWithFeeForFullPayment) +
              parseFloat(totalWithFeeForRecurringPayment) +
              parseFloat(totalWithFeeForDepositPayment) +
              parseFloat(totalWithFeeForDepositRecuringPayment)
            ).toFixed(2)}
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
};

export default OrderSummary;

OrderSummary.propTypes = {
  fee: PropTypes.number,
  discount: PropTypes.number,
  cartItems: PropTypes.array,
  promoDiscountValue: PropTypes.any,
  promoDiscountType: PropTypes.string,
};
